import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { copy } from "@/content";

const KEY = "ltc_privacy_ok";

export const PrivacyBanner = () => {
  const { lang } = useLanguage();
  const t = copy[lang].privacy;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const id = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(id);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-24 left-6 right-6 z-[95] md:bottom-6 md:right-auto md:max-w-md"
          data-testid="privacy-banner"
        >
          <div className="flex items-start gap-4 border border-white/15 bg-ink/95 p-5 shadow-2xl backdrop-blur-xl">
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />
            <div>
              <p className="font-tty text-xs leading-relaxed text-neutral-300" data-testid="privacy-banner-text">
                {t.text}
              </p>
              <button
                onClick={accept}
                data-testid="privacy-accept-button"
                className="mt-3 border border-acid px-4 py-2 font-tty text-[11px] uppercase tracking-widest text-acid transition-colors duration-300 hover:bg-acid hover:text-black"
              >
                {t.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
